import React from "react";
import Banner from "./banner";
import {
  descCodes,
  imagesCode,
  titleCodes,
} from "../../template_codes/nextgadget/home_page_codes";

const Carousel = () => {
  return (
    <>
      <div className="carousel w-full rounded-none md:rounded-2xl">
        <div id="item1" className="carousel-item w-full ">
          {/* Banner 1  */}

          <Banner
            image={imagesCode.banner1.image}
            title={titleCodes.title.title}
            desc={descCodes.desc.desc}
            text1={[
              "OS",
              "CPU",
              "Main Screen Display",
              "RAM",
              "Touch Screen Type",
              "Color",
            ]}
            text2={[
              "Windows",
              "Intel Core i3, Intel Core i5, Intel Core i7 ",
              '15", 15.6"',
              "4GB, 8GB",
              "Capacitive Screen",
              "Black",
            ]}
          />
        </div>
        <div id="item2" className="carousel-item w-full">
          {/* Banner 2  */}
          <Banner
            image={imagesCode.banner2.image}
            title={titleCodes.title1.title}
            desc={descCodes.desc1.desc}
          />
        </div>
        <div id="item3" className="carousel-item w-full">
          {/* Banner 3  */}
          <Banner
            image={imagesCode.banner3.image}
            title={titleCodes.title2.title}
            text1={[
              "Processor",
              "OS",
              "Graphics",
              "Memory",
              "Storage",
              "Display",
            ]}
            text2={[
              "12ᵗʰ Gen Intel® Core™ i5-1235U",
              "Windows 11 Home",
              "Intel® UHD Graphics",
              "8GB DDR4",
              "512 GB SSD",
              "15.6-in, Full HD (1920X1080)",
            ]}
          />
        </div>
        <div id="item4" className="carousel-item w-full">
          {/* Banner 4  */}
          <Banner
            image={imagesCode.banner4.image}
            title={titleCodes.title3.title}
          />
        </div>
      </div>
      <div className="flex justify-center w-full py-2 gap-2">
        <a
          href="#item1"
          className="btn btn-xs bg-gray-500 border-none shadow-lg hover:scale-105"
        >
          1
        </a>
        <a
          href="#item2"
          className="btn btn-xs bg-gray-500 border-none shadow-lg hover:scale-105"
        >
          2
        </a>
        <a
          href="#item3"
          className="btn btn-xs bg-gray-500 border-none shadow-lg hover:scale-105"
        >
          3
        </a>
        <a
          href="#item4"
          className="btn btn-xs bg-gray-500 border-none shadow-lg hover:scale-105"
        >
          4
        </a>
      </div>
    </>
  );
};

export default Carousel;
